import React, { ReactNode, useEffect, useMemo, useState } from 'react';



import { Box, Button, FormField, Link, Pagination, Popover, SpaceBetween, Table, TextFilter, TruncatedText } from '@cloudscape-design/components';
import { mdiAlertOctagon, mdiCamera, mdiCheckCircle, mdiEyeSettings, mdiFileExcel, mdiFlagVariantOff, mdiReload, mdiTimerSandComplete } from '@mdi/js';
import Icon from '@mdi/react';
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import * as XLSX from "xlsx";
import { getEquipment, setParameters } from '../../pages/commons/functions';
import { useGlobalState } from '../../pages/context/GlobalStateContext';
import { btnIconForm, ItemNote } from '../../resources/types';
import BadgeCustom from '../extras/BadgeCustom';
import SelectPaging from '../selects/selectPaging';


interface TableManttosProps {
    notes?: ItemNote[];
    showUser?: boolean;
    showEquipment?: boolean;
    excel?: boolean;
    filter?: boolean;
    refresh?: boolean;
    hidePaging?: boolean;
    onRefresh?: () => void; // ← optional now
    onSelect?: (selectedRow: any) => void; // ← optional now
    onRangeChange?: (startDate: string, endDate: string) => void; // ← optional now
    records?: number;
    //onDismiss: () => void;
    //onConfirm: (selectedDate: string) => void;
}

const TableManttos: React.FC<TableManttosProps> = ({
    notes = [],
    filter = true,
    showUser = true,
    showEquipment = true,
    hidePaging = false,
    excel = false,
    onSelect,
    onRefresh,
    onRangeChange,
    refresh = true
}) => {

    //const [movements, setMovements] = useState<ItemsMovement[]>([]);
    const { parameters, data } = useGlobalState();

    const [currentPageIndex, setCurrentPageIndex] = useState(1);
    const [filterValue, setFilterValue] = useState("");
    const [movementsExcel, setMovementsExcel] = useState<any[]>([]);
    const filtered: ItemNote[] = notes.filter((item: ItemNote) => {

        const normalize = (str: string | undefined | null) =>
            (str || "")
                .toString()
                .toLowerCase()
                .normalize("NFD") // Decomposes accented characters (e.g., 'í' -> 'i' + '◌́')
                .replace(/[\u0300-\u036f]/g, "") // Removes the accent marks
                .replace(/[^a-z0-9]/g, ""); // Removes non-alphanumeric

        const searchWords = normalize(filterValue).split(/\s+/).filter(Boolean);
        const text = normalize([item.displayName ?? "", item.note ?? "", item.registration ?? ""].join(" "));
        return searchWords.every((word) => text.includes(normalize(word)));
    });
    const paginated = filtered.slice((currentPageIndex - 1) * parameters.pageSize, currentPageIndex * parameters.pageSize);


    const exportToExcel = () => {
        // Convert JSON to worksheet

        let mExcel: any[] = (filtered.map((fl: ItemNote) => ({
            ID: fl.idMaintenance,
        })));
        const ws = XLSX.utils.json_to_sheet(mExcel);

        // Create a workbook
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Mantto");

        // Generate XLSX file and download
        XLSX.writeFile(wb, "mantto.xlsx");
    };
    const exportTableToPDF = (data: any[], columns: string[]) => {
        const doc = new jsPDF();

        doc.text("Movements", 14, 10);

        autoTable(doc, {
            head: [columns],
            body: data.map(row => columns.map(col => row[col])),
        });

        doc.save("movements.pdf");
    };

    const manttoNote = (item: ItemNote): ReactNode => {
        const textLong = item.note ?? "";

        if (textLong.length > 60) {
            return (
                <span title={textLong} style={{ display: 'inline-block', width: '100%' }}>
                    <TruncatedText>{textLong.substring(0, 60) + "..."}</TruncatedText>
                </span>
            );
        } else {
            return (<span>{textLong}</span>);
        }
    };
    useEffect(() => {
        setCurrentPageIndex(1);
    }, [notes]);

    const columns = useMemo(() => [
        {
            id: 'idMaintenance',
            header: 'ID/Fecha',
            cell: (item: ItemNote) => <FormField label={
                onSelect ?
                    <Link onClick={() => {
                        onSelect(item)
                    }}>
                        <div>
                            {item.idMaintenance}</div></Link> : item.idMaintenance}>
                {item.dateNote}

            </FormField>,
            width: 120,
        },
        showEquipment ?
            {
                id: 'equipment',
                header: 'Material',
                width: 160,
                cell: (item: ItemNote) => (
                    <FormField label={item.registration}>{getEquipment(item.idEquipment, data)?.groupType ?? ""}</FormField>
                )
            } : null,
        {
            id: 'tag',
            header: 'Etiquetas',
            width: 150,
            cell: (item: ItemNote) => {
                const popovers = [];
                if (item?.statusMant === 0) {
                    if (item.idUserRead && Array.isArray(item.idUserRead) && item.idUserRead.length > 0) {
                        popovers.push(
                            <Popover header="Estado" content={"Visualizada"} triggerType="custom">
                                <BadgeCustom color="light" size="small"><Icon path={mdiEyeSettings} size={0.75} /></BadgeCustom>
                            </Popover>
                        );
                    }
                    else {
                        popovers.push(
                            <Popover header="Estado" content={"No vista"} triggerType="custom">
                                <BadgeCustom color="light" size="small"><Icon path={mdiFlagVariantOff} size={0.75} /></BadgeCustom>
                            </Popover>
                        );
                    }
                }


                if (item?.statusMant === 1) {
                    popovers.push(

                        <Popover header="Estado" content={"En proceso"} triggerType="custom">
                            <BadgeCustom color="grey" size="small"><Icon path={mdiTimerSandComplete} size={0.75} /></BadgeCustom>
                        </Popover>
                    );
                } else if (item?.statusMant === 2) {
                    popovers.push(
                        <Popover header="Estado" content={"Finalizada"} triggerType="custom">
                            <BadgeCustom color="green" size="small"><Icon path={mdiCheckCircle} size={0.75} /></BadgeCustom>
                        </Popover>
                    );
                }


                if (item?.isOutOfFlight === 1) {
                    popovers.push(
                        <Popover header="Estado" content={"Material fue dejado fuera de vuelo"} triggerType="custom">
                            <BadgeCustom color="red" size="small"><Icon path={mdiAlertOctagon} size={0.75} /></BadgeCustom>
                        </Popover>
                    );
                }

                if (!!item.images && item.images.length > 0) {
                    popovers.push(
                        <BadgeCustom color="indigo" size="small"><Icon path={mdiCamera} size={0.75} /> {item.images.length}</BadgeCustom>
                    )
                }

                return <SpaceBetween direction="horizontal" size="xxxs">{popovers}</SpaceBetween>;
            }

        },
        {
            id: 'idUser',
            header: 'Piloto/Nota',
            cell: (item: ItemNote) => (

                <FormField label={item.displayName}>
                    <TruncatedText>
                        {item.note}
                    </TruncatedText>
                </FormField>
            ),
            maxWidth: 500,
        },
    ].filter(Boolean), [notes, paginated, filtered, currentPageIndex, parameters.pageSize, filterValue]);
    const dataManttos = hidePaging ? filtered : paginated;
    return (
        <>
            <Table

                variant="embedded"
                cellVerticalAlign='top'
                trackBy="idMaintenance"

                stickyHeader
                filter={
                    <FormField>
                        <SpaceBetween direction='horizontal' size='xs'>
                            {filter ? (

                                <div style={{ width: 300 }}>
                                    <TextFilter countText={filterValue === "" ? `${notes.length} registros` : `${paginated.length}/${notes.length}`}
                                        filteringPlaceholder="Filtrar"
                                        filteringText={filterValue}
                                        disabled={notes.length === 0}
                                        onChange={({ detail }) => {
                                            setFilterValue(detail.filteringText);
                                            setCurrentPageIndex(1);
                                        }}
                                    />
                                </div>
                            ) : undefined}
                            {onRefresh && (
                                <Button onClick={onRefresh} style={{ root: btnIconForm }}><Icon path={mdiReload} size={1} /></Button>

                            )}
                            {excel && (
                                <Button disabled={notes.length === 0} onClick={exportToExcel} style={{ root: btnIconForm }}><Icon path={mdiFileExcel} size={1} /></Button>
                            )}
                        </SpaceBetween>
                    </FormField>
                }
                pagination={
                    !hidePaging ?
                        <SpaceBetween direction="horizontal" size="xs" alignItems="center">
                            {filtered.length > parameters.pageSize && (
                                <Pagination
                                    currentPageIndex={currentPageIndex}
                                    pagesCount={Math.ceil(filtered.length / parameters.pageSize)}
                                    onChange={({ detail }) => setCurrentPageIndex(detail.currentPageIndex)}
                                />
                            )}

                            {notes.length > 0 && (
                                <SelectPaging onSelect={(pageSize) => {
                                    setCurrentPageIndex(1);
                                    setParameters({ ...parameters, pageSize: pageSize });
                                }} />
                            )}
                        </SpaceBetween>
                        : null
                }
                columnDefinitions={columns}
                items={dataManttos ?? []}
                empty={
                    <Box
                        margin={{ vertical: "xs" }}
                        textAlign="center"
                        color="inherit"
                    >
                        <SpaceBetween size="m">
                            <b>Sin mantenimientos asociados</b>
                        </SpaceBetween>
                    </Box>
                }
            />
        </>
    );
};

export default TableManttos;